import React, { FC } from "react";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

interface TooltipProps {
    children: React.ReactNode;
    title: string;
    spanClassname?: string;
    handleClick?: (id?: any) => void;
}

const ToolTip: FC<TooltipProps> = ({ children, title, spanClassname, handleClick }) => {

    return (
        <OverlayTrigger /* delay={{ hide: 450, show: 300 }} */
            overlay={(props) => (<Tooltip {...props}> {title} </Tooltip>)} placement="top">
            <span className={spanClassname} onClick={handleClick} style={{ display: "inline-block" ,width: "100%" }}> {children}</span>
        </OverlayTrigger>
    );
}
export default ToolTip; 